import { decoStitch } from '@/data/constants';

export default {
    computed: {
      defaultRecipe() {
        return this.$store.state.recipe.defaultRecipe;
      },
      recipe_v2() {
        return this.$store.state.recipe.recipe_v2;
      },
      decoStitchObj() {
        return this.$store.state.utils.pdm.components.decoStitch;
      },
      isDecoStichApplied(){
        return this.$store.state.geometryUpdates.decostitchApplied;
      }
    },
    methods: {
      /**
       * @function applyDecoStitch
       * @param {string} applyObj.swatchID - swatch id of the swatch applied
       * Apply show/hide process to the currentComponent
       */
      applyDecoStitch(swatch, component = '') {
        if(component === '' || component === this.decoStitchObj.options.componentToHide){
          return new Promise(resolve => {
            if(this.isDecoStichApplied && swatch.material_type !== decoStitch) {
              this.showComponent().then(() => {
                resolve();
              })
            } else {
              this.hideComponent(swatch.id).then(() => {
                resolve();
              })
            }
          });
        }
      },

      /**
       * @function  
       * @param {string}  path - path of the geometry file to load
       * Loads the geometry for deco stitch
       */
      loadStitchGeo(path, currentComponent) {
        return new Promise((resolve, reject)=>{
          this.$model3D.loadObject(path).then(geometry => {
            const mesh = geometry.getObjectByName('deco_stitches') || geometry.getObjectByName(`${currentComponent}_stitches`);
            //remove old stitches
            this.$model3D.sceneHelpers.removeSceneObjectByName(`${currentComponent}_stitches`);
            this.$model3D.sceneHelpers.removeSceneObjectByName('deco_stitches');
            // apply newly loaded stitches
            this.$model3D.modelObj.add(geometry.children[0].children[0]);
            this.$model3D.sceneHelpers.updateMaterialOptions({ mesh, options: this.pdm.components[currentComponent].stitches.material_options.mesh_options});
            resolve();
          }).catch(err => {reject(err)});
        });
      },
      /**
       * @function hideComponent
       * @param {string}  geometryOptionPath - The product options path to be logged in the recipe
       * Hides the "componentToHide" defined in th options object.
       */
      hideComponent(swatchID) {
        return new Promise((resolve, reject) => {
          this.$store.commit("geometryUpdates/SET_DECOSTITCH_APPLIED", true);
          const stitchObj = this.decoStitchObj;
          if(!stitchObj.options) resolve();

          const { s3ModelsBucket } = this.$store.state.endPoints.customizer;
          const componentName = stitchObj.options.componentToHide;
          const sizeToLoad = this.$store.state.sceneSetup.modelBySize;
          const modelSKU = this.pdm.parent_model ? this.pdm.parent_model : this.pdm.sku;
          const stitchesURL = this.$store.getters["utils/addCacheBusting"](`${s3ModelsBucket}gltf_models/${modelSKU}/${sizeToLoad}/stitches/deco_stitches.glb`);
          this.$store.commit("standardNavigation/UPDATE_MENU_STANDARD_NAVIGATION", { item: {id: componentName, isChecked: true }});

          this.loadStitchGeo(stitchesURL, componentName).then(() => {
            const color = this.$store.state.recipe.recipe_v2.components[this.$recipe.getUGCComponents()[0]]?.ugc.tonal_stitch_color 
              ?? this.$recipe.getDecostitchColorFromRecipeComponent({});

            this.toggleComponentVisibility(componentName, false);
            this.$eventBus.$emit("update-menu-item-state", componentName);

            if (color) {
              this.$model3D.sceneHelpers.updateComponentStitching({ componentName: "deco", color });
            }

            if (stitchObj.recipe_mapping) {
              this.applyRecipeMapping(componentName, stitchObj.recipe_mapping, swatchID).then(() => {
                resolve();
              })
            }
          });
          
        });
      },
      /**
       * @function showComponent
       * This function shows the component to hide/show in the options object
       * Calls applySwatch with component/swatch of component hidden/shown
       * Removes the product option from the recipe data
       */
      showComponent(){
        return new Promise((resolve, reject) => {
          this.$store.commit("geometryUpdates/SET_DECOSTITCH_APPLIED", false);
          const stitchObj = this.decoStitchObj;
          if(!stitchObj.options) resolve();
          
          const { s3ModelsBucket } = this.$store.state.endPoints.customizer;
          const componentName = stitchObj.options.componentToHide;
          const sizeToLoad = this.$store.state.sceneSetup.modelBySize;
          const modelSKU = this.pdm.parent_model ? this.pdm.parent_model : this.pdm.sku;
          const stitchesURL = this.$store.getters["utils/addCacheBusting"](`${s3ModelsBucket}gltf_models/${modelSKU}/${sizeToLoad}/stitches/${componentName}_stitches.glb`);

          this.loadStitchGeo(stitchesURL, componentName).then(()=>{
            this.updateComponentGeometryUpdate(componentName);
            this.toggleComponentVisibility(componentName, true);
            this.$model3D.sceneHelpers.updateComponentStitching({componentName});
            resolve();
          });
        })
      },
      /**
       * @function  toggleComponentVisibility
       * @param {string} componentName - String value representing the componenet name. Eg: "vamp"
       * @param {boolean} visibility - Boolean value used to set the visibility of the component on the model.component object.
       * Hides or shows the passed component based on the provide boloean value.
       */
      toggleComponentVisibility(componentName, visibility){
        const componentObj = this.$model3D.sceneHelpers.getSceneObjectByName({ objectName: componentName });
        if (componentObj && componentObj.material) {
          componentObj.visible = visibility;
        }
      },
      /**
       * @function applyRecipeMapping
       * @param {Object}  recipeMapping - The recipe values to update
       * Applies recipe mapping to align product option recipe values with the recipe.
       */
      applyRecipeMapping(componentName, recipeMapping, swatchID = this.recipe_v2.components[componentName].swatch_id) {
        return new Promise((resolve, reject) => {
          const recipeMapEntry = recipeMapping.components[componentName];
          this.$recipe.updateComponents(componentName, swatchID, null, recipeMapEntry).then(() => {
            resolve();
          })
        });
      },
      /**
         * @function updateComponentGeometryUpdate
         * @param {String} component
         * This function UPDATES component
         */
      updateComponentGeometryUpdate(component) {
        const { components } = this.recipe_v2;
        let data = components[component];
        this.$store.commit("recipe/UPDATE_COMPONENT", { componentName: component, data });
      },
      removeDecostitchWhenUGCRemoved({ swatch,  componentIsUGC, activeComponentIsUGC} ) {
        if(!componentIsUGC && !activeComponentIsUGC) return;
        if (!this.isDecoStichApplied || swatch.swatchAllowsDecostitchInComponent) {
          const color = this.$recipe.getDecostitchColorFromRecipeComponent({swatch});
          if(color) this.$model3D.sceneHelpers.updateComponentStitching({ componentName: "deco", color});
          return;
        }
        const componentName = this.decoStitchObj.options.componentToHide;
        this.showComponent();
        const swatchID = this.defaultRecipe.components[componentName] && this.defaultRecipe.components[componentName].swatch_id;
        if (swatchID) {
          this.applySwatch(componentName, swatchID);
        }
      },
      reApplyDecostitch() {
        if(this.isDecoStichApplied) {
          const componentName = this.decoStitchObj.options.componentToHide;
          const recipeComponent = this.recipe_v2.components[componentName];
          this.hideComponent("3456");
          this.$store.commit("swatches/SET_SWATCHES_SELECTED", {
            component: componentName,
            data: {
              swatchId: "3456",
              group: recipeComponent.group,
              subgroup: recipeComponent.subgroup
            }
          });
        }
      }
    }
  };
